import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { 
    withStyles,
    Grid,
    Button,
    TextareaAutosize
  } from '@material-ui/core';
import '../../../scss/component/onboarding/company_profile.scss'
import uuid from 'uuid';


const useStyles = (theme) => ({
    root: {
      width: '100%',
    },
    button: {
        borderColor:'gray',
        '&:hover': {
            background: '#5B9FAB',
            borderColor: '#5B9FAB',
            color: 'white'
        },
        color: 'gray'
    },
    selectedButton: {
        background: '#5B9FAB',
        borderColor: '#5B9FAB',
        color: 'white',
        '&:hover': {
            background: '#5B9FAB',
            borderColor: '#5B9FAB',
            color: 'white'
        },
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  });

class CompanyProfileStepTwo extends PureComponent{

    constructor (props) {
    super(props)
        this.state = {
            deliveredInPerson: props.deliveryMethod === "In-Person" ? true : false,
            deliveredRemote: props.deliveryMethod === "Remote" ? true : false,
            deliveredBoth: props.deliveryMethod === "Both" ? true : false,
            workOnsite: props.employeeWorkType === "Onsite" ? true : false,
            workRemote: props.employeeWorkType === "Remote" ? true : false,
            workBoth: props.employeeWorkType === "Both" ? true : false,
        }

        this.selectDeliveredInPerson = this._selectDeliveredInPerson.bind(this)
        this.selectDeliveredRemote = this._selectDeliveredRemote.bind(this)
        this.selectDeliveredBoth = this._selectDeliveredBoth.bind(this)
        this.selectWorkOnsite = this._selectWorkOnsite.bind(this)
        this.selectWorkRemote = this._selectWorkRemote.bind(this)
        this.selectWorkBoth = this._selectWorkBoth.bind(this)
    }

    _selectDeliveredInPerson(value,saveDeliveryMethod){
        this.setState({deliveredInPerson:true})
        this.setState({deliveredRemote:false})
        this.setState({deliveredBoth:false})
        saveDeliveryMethod(value)
    }

    _selectDeliveredRemote(value,saveDeliveryMethod){
        this.setState({deliveredInPerson:false})
        this.setState({deliveredRemote:true})
        this.setState({deliveredBoth:false})
        saveDeliveryMethod(value)
    }

    _selectDeliveredBoth(value,saveDeliveryMethod){
        this.setState({deliveredInPerson:false})
        this.setState({deliveredRemote:false})
        this.setState({deliveredBoth:true})
        saveDeliveryMethod(value)
    }

    _selectWorkOnsite(value,saveWorkType){
        this.setState({workOnsite:true})
        this.setState({workRemote:false})
        this.setState({workBoth:false})
        saveWorkType(value)
    }

    _selectWorkRemote(value,saveWorkType){
        this.setState({workOnsite:false})
        this.setState({workRemote:true})
        this.setState({workBoth:false})
        saveWorkType(value)
    }

    _selectWorkBoth(value,saveWorkType){
        this.setState({workOnsite:false})
        this.setState({workRemote:false})
        this.setState({workBoth:true})
        saveWorkType(value)
    }

    render(){
        const { classes, saveDescription,
            saveDeliveryMethod,
            saveWorkType,
            companyDescription 
        } = this.props;
        return(
            <div>
                <div id="form_title">
                    <h3>Step 2: Tell us a bit about how your business works</h3>
                </div>
                <div className="form_container_short">
                    <form>
                        <label>Describe what your company does in one sentence.</label><br/>
                        <TextareaAutosize 
                            aria-label="minimum height" 
                            rowsMin={5} 
                            cols={80} 
                            placeholder="Eg: We create invoicing software." 
                            defaultValue={companyDescription}
                            onChange={(event)=>{saveDescription(event.target.value)}}
                            /> <br/><br/>
                        <Grid container spacing={2}>
                            <Grid key={uuid()} item md={6} id="left_grid_step2">
                                <label>How is your product/service delivered?</label><br/>
                                <Button 
                                className={this.state.deliveredInPerson ? classes.selectedButton : classes.button}
                                variant="outlined"
                                color="primary"
                                onClick={()=>{this.selectDeliveredInPerson('In-Person',saveDeliveryMethod)}}>
                                    IN-PERSON
                                </Button>
                                <Button
                                className={this.state.deliveredRemote ? classes.selectedButton : classes.button}
                                variant="outlined"
                                color="primary"
                                onClick={()=>{this.selectDeliveredRemote('Remote',saveDeliveryMethod)}}>
                                    REMOTE
                                </Button>
                                <Button
                                className={this.state.deliveredBoth ? classes.selectedButton : classes.button}
                                variant="outlined"
                                color="primary"
                                onClick={()=>{this.selectDeliveredBoth('Both',saveDeliveryMethod)}}>
                                    BOTH
                                </Button>
                            </Grid>
                            <Grid key={uuid()} item md={6} id="right_grid_step2">
                                <label>Where do your employees work?</label><br/>
                                <Button
                                className={this.state.workOnsite ? classes.selectedButton : classes.button}
                                variant="outlined"
                                color="primary"
                                onClick={()=>{this.selectWorkOnsite('Onsite',saveWorkType)}}>
                                    ONSITE
                                </Button>
                                <Button
                                className={this.state.workRemote ? classes.selectedButton : classes.button}
                                variant="outlined"
                                color="primary"
                                onClick={()=>{this.selectWorkRemote('Remote',saveWorkType)}}>
                                    REMOTE
                                </Button>
                                <Button
                                className={this.state.workBoth ? classes.selectedButton : classes.button}
                                variant="outlined"
                                color="primary"
                                onClick={()=>{this.selectWorkBoth('Both',saveWorkType)}}>
                                    BOTH
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </div>
        )
    }
}

export default withRouter(withApollo((withStyles(useStyles)(CompanyProfileStepTwo))))


// WEBPACK FOOTER //
// ./src/components/onboarding/components/CompanyProfileStepTwo.js